import React from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

import { formatNull, formatDateTime } from '../Utils/GlobalUtils';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeadlinePanel from '../Components/HeadlinePanel';

import Loading from '../Components/Loading';
import LoadingLines from '../Components/LoadingLines';
import WarningPanel from '../Components/WarningPanel';

export default function LastentriesMessages() {
  const { openTimeModal } = useTimeModal();
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedType, setSelectedType] = React.useState('message');
  const [entries, setEntries] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [reload, setReload] = React.useState(true);

  const [limitForView, setLimitForView]= React.useState(20);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);
    
    axios.get(`/api/get-last-cases-messages?type=${selectedType}&limitForView=${limitForView}`, {
      headers: {
          Authorization: `Bearer ${token}`,
      }
    }).then(response => {
        setWarning('');
        setEntries(response.data);
    })
    .catch(error => {
        setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    })
  }, [reload, selectedType]);

  return (
    <>
      <div className='mainContainer'>
        <HeadlinePanel label= 'Последние сообщения в карточках' type='' />
        <div className='containerInner'>
          <div className='pageWrapper'>
            <div className='radioSwitchWrapper'>
                <label className={`radioSwitchLabel ${selectedType === 'message' ? 'selected' : ''}`}>
                    <input
                        type='radio'
                        name='typeSelector'
                        value='message'
                        checked={selectedType === 'message'}
                        onChange={(e) => setSelectedType(e.target.value)}
                    />
                    <span>Сообщения</span>
                </label>
                <label className={`radioSwitchLabel ${selectedType === 'change_data' ? 'selected' : ''}`}>
                    <input
                        type='radio'
                        name='typeSelector'
                        value='change_data'
                        checked={selectedType === 'change_data'}
                        onChange={(e) => setSelectedType(e.target.value)}
                    />
                    <span>События</span>
                </label>
            </div>
            <div className='tableContainer withoutPaddings'>
              {(entries.length===0 && loading)? <LoadingLines />
              : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
              : entries.map((entry) => 
                  <motion.div
                    className='tableRow nonActive' 
                    key={entry.id}
                    initial={{ scale: '97%', opacity: 0 }}
                    animate={{ scale: '100%', opacity: 1 }}
                    exit={{ scale: '97%', opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{ gridTemplateColumns: '10fr 25fr 15fr 45fr' }}
                  >
                    <div>
                      <p
                        className='monoTime'
                      >
                        {formatDateTime(entry.created_at)}
                      </p>
                    </div>
                    <div>
                      {entry.lastname ?
                      <Link
                        className='aWithLink'
                        to={`/account/${entry.initiator_id}`}
                      >
                        {entry.lastname} {entry.firstname} {entry.surname}
                      </Link>
                      :
                      <p>
                        Системное сообщение  
                      </p>}
                    </div>
                    <div>
                      <Link
                        className='aWithLink'
                        to={`/case/${entry.case_id}`}
                      >
                        {formatNull(entry.case_number)}
                      </Link>
                    </div>
                    <div
                      className={`${entry.type=='appointment_refusal' && 'colorCell red'}`}
                    >
                      {entry.type=='appointment_refusal' && <p>[Отказ от назначения]</p>}
                      <p>{entry.content}</p>
                    </div>
                  </motion.div>
              )}
              {!warning && entries.length > 0 && (entries.length < entries[0].total_count) && (
                  <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                      <div></div>
                      <div>
                          <button
                              type='button'
                              className='button'
                              style={{ width: 'fit-content' }}
                              onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                              disabled={loading}
                          >
                              {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                          </button>
                      </div>
                      <div></div>
                  </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}